/**
 * Деньги в API STO-210: в ответах — строка ("500.00"), в запросах — number.
 * Пустая ячейка — null, не 0.
 */

export const formatMoneyRub = (value: string | null | undefined): string => {
  if (value === null || value === undefined || value === '') {
    return '—';
  }

  const numeric = Number(value);
  if (Number.isNaN(numeric)) {
    return '—';
  }

  const formatted = numeric % 1 === 0 ? numeric.toString() : numeric.toFixed(2);
  return `${formatted} ₽`;
};

export const moneyValueToInputString = (value: string | null | undefined): string => {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const numeric = Number(value);
  if (Number.isNaN(numeric)) {
    return '';
  }

  return numeric.toString();
};

export const parseMoneyInput = (raw: string): number | null => {
  const trimmed = raw.trim().replace(',', '.');
  if (trimmed === '') {
    return null;
  }

  const numeric = Number(trimmed);
  return Number.isNaN(numeric) ? null : numeric;
};
